import Card from "../general-site-stuff/Card";

function AboutSection() {
    return (
        <div id="about" className="aboutSection"> 
            <div className="aboutSectionHeader">
                <h1>
                    ABOUT
                </h1> 
            </div>
            <div className="content">
                <div className="column">
                <Card
                type="text"
                title="WHAT IS ONLINE RADICALISATION?" 
                description={
                    <>
                        <p>
                            Get doomscrolled into a cult? Radicalised through memes in your feed?
                            Yeah, it’s real. And it's more common than you think! *
                        </p>
                        
                        <p>
                        <hr style={{ border: '1px solid #444', margin: '1rem 0' }} /> {/* line thingy */}

                            <span style={{ fontWeight: 'bold', color: '#eda138'}}>Online Radicalisation</span> is 
                            when people are gradually pulled into extreme beliefs through manipulative content - 
                            and it doesn’t just happen by accident.
                        </p>
                        <p>
                            It often starts subtly: a spicy headline, a relatable meme, a comment that makes you go:
                            
                            <Card
                            type="smallerImage"
                            src="/assets/images/AboutSection/“....wait, do they have a point”.png"
                            alt="Speech Bubble Saying '...wait do they have a point?'" />
                            
                        </p>
                        <p>
                            You engage - a like, a scroll, a share, or maybe just a pause. Platforms notice
                            and you're shown more content just like that. Not because it’s trying to radicalise you,
                            but because it prioritises content that keep you online... and online time drives profit.
                        </p>                        
                        <p>
                            This kind of system doesn’t care if the content is helpful, accurate, or harmful - it
                            cares if people click. And content designed to trigger strong emotions (like anger,
                            fear, or loyalty) tend to perform really well.
                        </p>   
                        <p>
                            That’s where threat actors come in - extremists, political operatives, coordinated
                            bot accounts. They craft content designed to exploit these emotional triggers and
                            take advantage of how platforms rank and spread posts.
                        </p> 
                        <p>
                            The result? Over time, your feed becomes more one-sided. You stop seeing different
                            viewpoints. You get used to black-and-white thinking; “us vs them,” “truth vs lies,”
                            “heroes vs villains.”
                        </p>
                        <p>
                            That’s how online radicalisation often happens - not through brainwashing, but through
                            repetition, emotional pressure, and selective exposure.
                        </p>
                        <hr style={{ border: '1px solid #444', margin: '1rem 0' }} /> {/* line */} 
                        <p>
                            <span style={{ fontWeight: 'bold', color: '#eda138'}}>This site helps you spot those patterns early. </span>
                        </p> 
                        <p>
                            <span style={{ fontStyle: 'italic', color: '#a0a0a0'}}>
                            *that opening line used a classic manipulative tactic: emotionally loaded language + urgency.  
                            did you catch it? head to the <a href="/learn">learn page</a> to find out how this stuff works.
                            </span>
                        </p>
                    </>
                } />

                <Card
                type="image"
                src="/assets/images/AboutSection/truth_exposed.png"
                alt="Illustrative Image" />
                </div>

                <div className="column">
                <Card
                type="image"
                src="/assets/images/AboutSection/phone2.png"
                alt="Illustrative Image" />

                <Card
                type="text"
                title="WHY IS THIS IMPORTANT?"
                description={
                <>   
                    <p>
                    <span style={{ fontWeight: 'bold', color: '#eda138'}}>Online Radicalisation</span> isn’t just a niche problem - it’s something anyone can be 
                    exposed to. And most people don’t even realise it’s happening while it’s happening.
                    </p>
                    <p>
                        Manipulative content is designed to feel normal, even entertaining. 
                        That’s what makes it effective - and dangerous. 
                    </p>    
                    <p>    
                        When polarising content dominates your feed, it quietly shifts 
                        how you see the world: who you trust, who you blame, and what you believe is “truth.”
                    </p>
                    <p>
                        Left unchecked, this doesn’t just affect individuals - it fractures whole communities. 
                    </p>    
                    <p>
                        <span style={{ fontWeight: 'bold', color: '#eda138'}}>It spreads hate and potentially real-world violence.</span>  
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold', color: '#eda138'}}>It fuels misinformation.</span>
                    </p>
                    <p>    
                        <span style={{ fontWeight: 'bold', color: '#eda138'}}>And new AI tools, like ChatGPT, make it even easier to produce believable, extreme content at scale.</span>
                    </p>
                    <p>
                        That’s why learning to recognise these tactics matters.
                    </p>

                    <Card
                    type="image" 
                    style={{ display: 'block', margin: '2rem auto', width: '100%', maxWidth: '100%' }}
                    src="/assets/images/AboutSection/longbubble.png" alt="Speech Bubble Saying 'This site isn’t about telling you what to think - it’s about recognising tactics and helping you think for yourself'" />
            
                </>
                } /> 
                </div>
            </div>



        </div>
    );
}

export default AboutSection;